import Cookie from 'js-cookie'

/**
 * トラッキングツールの利用可否を判定する
 */
export const canUseTrackingTool = () => {
  // SSR中は使用不可
  if (typeof window === 'undefined') return false
  // ログインユーザかどうかを判定する
  const smAt = Cookie.get('sm_at')
  // 非ログインユーザは許可する
  if (!smAt) return true
  // 同意が得られていないユーザはブロックする
  // ※ 文字列で入っているはずだが念の為数値でも判定する
  const smAgPrd = Cookie.get('sm_ag_prd')
  return smAgPrd == 1
}
